import React from "react";

const Trustees_Members_DirectorsTabs = () => {
  return <> Trustees / Members / Directors </>;
};

export default Trustees_Members_DirectorsTabs;